import { DateTimeInput, Grid, TextInput } from '@ts/storybook';
import WrapperEntitySelector from '@modules/entitySelector/WrapperEntitySelector';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { IForm } from '@ts/ui-models';

interface ILicenseFormProps extends IForm {}

const LicenseForm = (props: ILicenseFormProps) => {
  const { mode, values, requiredFields, onChange, onCallbackChange } = props;

  const { type: licenseType, licenseTypeLid, licenseValidStart, licenseValidEnd, value, organization: organization0 } = values;

  const organization = organization0;

  const isViewMode = mode === 'view';

  const _handleChangeEntitySelector = (entity, entityName, fkField) => {
    const value = entity ? entity.logicalId : null;
    onChange(entityName, entity);
    onChange(fkField, value);
  };

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <WrapperEntitySelector
          label="License types"
          value={(licenseType && licenseType.id) || licenseTypeLid}
          onChangeEntity={entity => _handleChangeEntitySelector(entity, 'licenseType', 'licenseTypeLid')}
          searchComponent={generateSearchEntitySelector('licenseType')}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <WrapperEntitySelector
          label="Organization"
          value={organization}
          onChangeEntity={entity => _handleChangeEntitySelector(entity, 'ownerOrganization', 'ownerOrganizationId')}
          searchComponent={generateSearchEntitySelector('organization')}
          isReadOnly={isViewMode}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <DateTimeInput
          onlyDate
          labelDate={'License valid start'}
          value={licenseValidStart}
          onChange={onCallbackChange('licenseValidStart')}
          isReadOnly={isViewMode}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <DateTimeInput
          onlyDate
          labelDate={'License valid end'}
          value={licenseValidEnd}
          onChange={onCallbackChange('licenseValidEnd')}
          isReadOnly={isViewMode}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <TextInput
          isReadOnly={isViewMode}
          label="License value"
          value={value}
          onChangeValue={onCallbackChange('value')}
          required={requiredFields.includes('value')}
        />
      </Grid>
    </Grid>
  );
};

export default LicenseForm;
